import React from "react";
import {cx} from "../../lib/ClassSet";
import "./ReferralCodeItem.css";

function boolToString(bool) {
  if (bool === true) return "Active";
  return "Deactivated";
}

const ReferralCodeItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "referral-code-list-item": true,
    "u-selected": props.selected,
    "u-active": data.get("active") === true,
    "u-deactivated": data.get("active") !== true,
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-code">{data.get("code")}</td>
      <td className="field f-description">{data.get("description")}</td>
      <td className="field f-status">{boolToString(data.get("active"))}</td>
    </tr>
  )
}

export default ReferralCodeItem;